module.exports = __webpack_public_path__ + "img/logo_plugfest.9afa25cd.svg";